module.exports = __webpack_public_path__ + "img/QRIS_logo.aeaffdb4.svg";